"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
const StyledListItem = styled_1.default.li({
    display: 'flex',
    alignItems: 'center',
    padding: '8px 18px',
    fontWeight: 400,
    marginTop: 2,
    marginBottom: 2
}, ({ theme }) => ({
    fontSize: theme.typography.fontSize.medium,
    color: theme.palette.colors.coolGrey
}));
exports.default = StyledListItem;
//# sourceMappingURL=StyledListItem.js.map